import axios from 'axios'
import qs from 'qs'
import { API_BASE_URL } from '../config/api'
import { configureAxiosDefaults, get, post, postImage, put, putImage, remove, removeAxiosTokenHeader } from './utils'

export function configureToken(token) {
  configureAxiosDefaults('Authorization', token ? `Bearer ${token}` : null)
}

export const refreshToken = refresh => {
  const url = `${API_BASE_URL}/api/token/refresh/`
  return axios.post(url, { refresh })
}

export function removeAxiosToken() {
  removeAxiosTokenHeader()
}

export const getUserToken = data => {
  const url = '/api/token/'
  return post(url, data)
}

export const signUp = data => {
  const url = '/api/register/'
  return post(url, data)
}

export const googleLogin = data => {
  const url = '/api/auth/google/'
  return post(url, data)
}


export const resetPassword = data => {
  const url = '/api/request-password-reset/'
  return post(url, data)
}

export const validateAccount = data => {
  const url = '/api/validate-account/'
  return post(url, data)
}

export const verifyActiveAcount = params => {
  const url = `/api/validate-account/?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

export const confirmPassword = data => {
  const url = '/api/password-reset/'
  return post(url, data)
}


export const getMe = () => {
  const url = '/auth/users/me/'
  return get(url)
}

export const getProfile = () => {
  const url = `/api/me/`
  return get(url)
}

export const setTheme = data => {
  const url = '/api/themes/'
  return postImage(url, data)
}

export const getTheme = () => {
  const url = '/api/themes/'
  return get(url)
}


// DASHBOARD

export const getDashboard = (params) => {
  const getParams = {
    latitude: params.latitude,
    longitude: params.longitude,
    start: params.start,
    end: params.end,
    distance: params.distance,
    spaces: params.spaces,
    order_dir: params.order_dir,
    page_size: params.page_size,
    page_number: params.page_number,
  };
  const url = `/api/dashboard/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url)
}




//  EVENTS

export const getEvents = () => {
  const url = '/api/events/'
  return get(url)
}

export const setEvent = data => {
  const url = '/api/events/'
  return post(url, data)
}

export const updateEvent = data => {
  const url = `/api/events/${data?.slug}`
  return put(url, data)
}


export const setEvents = data => {
  const url = '/api/events-list/'
  return post(url, data)
}


export const getEvent = (slug) => {
  const url = `/api/event-info/${slug}`
  return get(url)
}

export const getPublicEvent = (slug) => {
  const url = `/api/public/event-info/${slug}`
  return get(url)
}

export const getEventTicket = (slug) => {
  const url = `/api/event-ticket/${slug}`
  return get(url)
}

export const getPublicEventTicket = (slug) => {
  //const url = `/api/public/event-ticket/${slug}`
  const url = `/api/event-ticket/${slug}`
  return get(url)
}

export const joinEvent = data => {
  const url = '/api/event-ticket/'
  return post(url, data)
}


export const updateEventTicket = (slug, data) => {
  const url = `/api/event-ticket/${slug}`
  return put(url, data)
}

export const uploadEventTicketAvatar = (slug, photo) => {

  const url = `/api/event-ticket/${slug}`
  const form = new FormData();
  form.append('avatar', photo);

  return putImage(url, form)
}

export const uploadEventImage = (slug, photo, target) => {

  const url = `/api/events/${slug}`
  const form = new FormData();
  form.append(target, photo);

  return putImage(url, form)
}

export const uploadVenueImage = (slug, photo, target) => {

  const url = `/api/venues/${slug}`
  const form = new FormData();
  form.append(target, photo);

  return putImage(url, form)
}

export const uploadEventBackground = (slug, photo) => {

  const url = `/api/events/${slug}`
  const form = new FormData();
  form.append('background', photo);

  return putImage(url, form)
}

export const uploadVenueGalleryImage = (image, order_line, venue) => {
  const url = `/api/venue-gallery/`;
  const form = new FormData();

  // 'photo' is the key, and `order_line` and `venue` are passed as additional fields
  form.append('image', image); // Assuming 'photo' is the form field for the image
  form.append('order_line', order_line); // Field for order
  form.append('venue', venue); // Field for venue

  return postImage(url, form);
};

export const updateVenueGallery = data => {
  const url = `/api/venue-gallery/${data?.slug}`
  return put(url, data)
}

export const deleteVenueGalleryItem = data => {
  const url = `/api/venue-gallery/${data?.slug}`
  return remove(url, data)
}

export const getTagsWithCategory = (category) => {

  const params = {
    category,
  }
  let url = `/api/tags/?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

// Community and groups
export const getEventTags = (group) => {

  const params = {
    group,
  }
  let url = `/api/event-tags/?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

export const eventTicketAction = data => {
  const url = '/api/event-ticket-action/'
  return post(url, data)
}

export const validateTicket = (slug, data) => {
  const url = `/api/event-validate-ticket/${slug}`
  return post(url, data)
}

// Profile

export const updateProfile = data => {
  const url = '/api/me/'
  return put(url, data)
}

// Community and groups
export const getCommunity = (slug) => {
  const url = `/api/community/${slug}`
  return get(url)
}

// Community and groups
export const getCommunityPublic = (slug) => {
  const url = `/api/public/community/${slug}`
  return get(url)
}

// Community and groups
export const getCommunities = () => {
  const url = `/api/communities/`
  return get(url)
}

// Community and groups
export const getRecommendedCommunities = () => {
  const url = `/api/communities-recommended/`
  return get(url)
}



// Community and groups
export const getCommunitiesForMember = () => {
  const url = `/api/communities-member/`
  return get(url)
}

export const joinCommunity = data => {
  const url = '/api/community-join/'
  return post(url, data)
}

export const postCommunityAnswers = (slug, data) => {
  const url = `/api/community/${slug}/admission-answers/`
  return post(url, data)
}

export const joinCommunityGuest = data => {
  const url = '/api/community-join-guest/'
  return post(url, data)
}

// Community and groups
export const getCommunityActivity = (slug, params) => {
  const url = `/api/community-activity/${slug}?${qs.stringify(params, { skipNulls: true })}`
  return get(url);
}

export const setCommunity = data => {
  const url = `/api/groups/`
  return post(url, data)
}


export const updateCommunity = data => {
  const url = `/api/community/${data?.slug}`
  return put(url, data)
}

export const uploadCommunityImage = (slug, photo, target) => {

  const url = `/api/community/${slug}`
  const form = new FormData();
  form.append(target, photo);

  return putImage(url, form)
}

export const uploadCommunityBackground = (slug, photo) => {

  const url = `/api/community/${slug}`
  const form = new FormData();
  form.append('background', photo);

  return putImage(url, form)
}

export const uploadProfileImage = (target, photo) => {

  const url = `/api/me/`
  const form = new FormData();
  form.append(target, photo);

  return putImage(url, form)
}


// Community and groups
export const searchCommunities = (params) => {
  const url = `/api/communities/?${qs.stringify(params, { skipNulls: true })}`
  //const url = `/api/communities/`
  return get(url)
}

// Public community search - no authentication required
export const searchPublicCommunities = (params) => {
  const url = `/api/public/communities/search/?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

// Community tariffs for a venue
export const getCommunityTariffs = (venueSlug, groupSlug) => {
  const url = `/api/venue-community-tariffs/${venueSlug}/${groupSlug}`
  return get(url)
}

export const createCommunityTariff = (venueSlug, groupSlug, data) => {
  const url = `/api/venue-community-tariffs/${venueSlug}/${groupSlug}`
  return post(url, data)
}

// Memberships
export const validateCommunityMembership = data => {
  const url = `/api/validate-community-membership/`
  return put(url, data)
}

// Community and groups
export const getVenues = () => {
  const url = `/api/venues/`
  return get(url)
}

// Create a new venue
export const createVenue = (data) => {
  const url = '/api/venues/'
  return post(url, data)
}

// Community and groups
export const getVenuesGroup = (slug) => {
  const url = `/api/venues-group/${slug}`
  return get(url)
}

// Get groups for a venue (community pricing)
export const getVenueGroups = (venueSlug) => {
  const url = `/api/venue-groups/${venueSlug}`
  return get(url)
}

// Add a group to a venue
export const addVenueGroup = (venueSlug, groupSlug) => {
  const url = `/api/venue-groups/${venueSlug}`
  return post(url, { group_slug: groupSlug })
}

// Remove a group from a venue
export const removeVenueGroup = (venueSlug, groupSlug) => {
  const url = `/api/venue-groups/${venueSlug}`
  return remove(url, { group_slug: groupSlug })
}


// Venue
export const getVenue = (slug, params) => {
  const url = `/api/venue-info/${slug}?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

export const getVenuePrice = (slug, params) => {
  const url = `/api/venue-prices/${slug}?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

export const getVenueActivity = (slug, params) => {
  const url = `/api/venue-activity/${slug}?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

export const getVenueResources = (slug, params) => {
  const url = `/api/venue-resources/${slug}?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

// Get community bookings at a venue for calendar display
export const getVenueCommunityBookings = (slug, params) => {
  const url = `/api/venue-community-bookings/${slug}?${qs.stringify(params, { skipNulls: true })}`
  return get(url)
}

// Venue
export const getVenueStaff = (slug) => {
  const url = `/api/venues/${slug}`
  return get(url)
}

export const updateVenue = data => {
  const url = `/api/venues/${data?.slug}`
  return put(url, data)
}

// Campaigns
// Community and groups
export const getCampaigns = () => {
  const url = `/api/campaigns/`
  return get(url)
}

export const getMessageBoard = () => {
  const url = `/api/campaign-messages/`
  return get(url)
}



export const createCampaign = data => {
  const url = '/api/campaigns/'
  return post(url, data)
}


// Bookings


export const createBooking = data => {
  const url = '/api/bookings/'
  return post(url, data)
}

export const createBookingPlan = data => {
  const url = '/api/booking-plans/'
  return post(url, data)
}


export const joinBooking = data => {
  const url = '/api/join-bookings/'
  return post(url, data)
}

export const validateBookingPayment = (sessionId) => {
  const url = `/purchase-success/${sessionId}`
  return get(url)
}

export const getBookings = (params) => {
  const getParams = {
    status: params.status,
    venue: params.venue,
    code: params.code,
    date: params.date,
    order_by: params.order_by,
    order_dir: params.order_dir,
    page_size: params.page_size,
    page_number: params.page_number,
  };

  const url = `/api/bookings/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url);
};

export const getBooking = (slug) => {
  const url = `/api/bookings/${slug}`
  return get(url)
}

export const getGroupBooking = (slug) => {
  const url = `/api/booking-plan/${slug}`
  return get(url)
}

export const updateBooking = data => {
  const url = `/api/bookings/${data?.slug}`
  return put(url, data)
}

export const getSearchMap = (params) => {
  const getParams = {
    latitude: params.latitude,
    longitude: params.longitude,
    start: params.start,
    end: params.end,
    distance: params.distance,
    spaces: params.spaces,
    area: params.area,
    booking_type: params.booking_type,
    order_dir: params.order_dir,
    page_size: params.page_size,
    page_number: params.page_number,
  };

  const url = `/api/search-map/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url)
}

export const getSearchHome = (params) => {
  const getParams = {
    location: params.location,
  };
  const url = `/api/search-home/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url)
}


export const getAvailableGroupBooking = (params) => {
  const { group, venue, booking } = params
  const getParams = {
    group,
    venue,
    booking,
  }
  const url = `/api/group-available-bookings/?${qs.stringify(getParams, { skipNulls: true })}`
  return get(url)
}

export const acceptBooking = data => {
  const url = '/api/accept-booking/'
  return post(url, data)
}

export const getBookingPlans = () => {
  const url = `/api/booking-plans/`
  return get(url)
}


//Members
export const getGroupMembers = (params) => {
  const getParams = {};
  if (params.searchQuery) getParams.searchQuery = params.searchQuery;
  if (params.tags && params.tags.length > 0) getParams.tags = params.tags;
  if (params.order_by) getParams.order_by = params.order_by;
  if (params.order_dir) getParams.order_dir = params.order_dir;
  if (params.page_size) getParams.page_size = params.page_size;
  if (params.page_number) getParams.page_number = params.page_number;

  // Use arrayFormat: 'repeat' to avoid sending indices in query parameters
  const queryString = qs.stringify(getParams, { skipNulls: true, arrayFormat: 'repeat' });
  const url = `/api/group-members/${params.community}${queryString ? `?${queryString}` : ''}`;
  return get(url);
};


// Tenants
export const updateTenant = data => {
  const url = `/api/tenants/${data?.slug}`
  return put(url, data)
}


// Tariffs
export const getTariffs = (params) => {
  const getParams = {
    status: params.status,
    work_area: params.work_area,
    booking_type: params.booking_type,
    resource: params.resource,
    group: params.group,
    venue: params.venue,
  };
  const url = `/api/tariffs/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url)
}

// Tariffs
export const updateTariff = data => {
  const url = `/api/tariffs/${data?.slug}`
  return put(url, data)
}

export const createTariff = data => {
  const url = `/api/tariffs/`
  return post(url, data)
}

export const createTariffRule = data => {
  const url = `/api/tariff-rules/`
  return post(url, data)
}

// Open Times
export const updateOpenTimes = data => {
  const url = `/api/open-times/${data?.slug}`
  return put(url, data)
}

export const sendVerificationCode = data => {
  const url = `/api/request-code/`
  return post(url, data)
}

export const validateVerificationCode = data => {
  const url = `/api/validate-code/`
  return post(url, data)
}

export const suscribeNewsletter = data => {
  const url = `/api/suscribe-newsletter/`
  return post(url, data)
}

export const sendFeedback = data => {
  const url = `/api/send-feedback/`
  return post(url, data)
}

export const checkVerificationStatus = data => {
  const url = `/api/verification-status/`
  return post(url, data)
}

export const confirmCookies = data => {
  const url = '/api/cookie-preferences/'
  return post(url, data)
}

export const getCookiePreferences = () => {
  const url = '/api/cookie-preferences/'
  return get(url)
}

export const getStaffMembers = (params) => {
  const getParams = {
    role: params.role,
    status: params.status,
    search: params.search,
    order_by: params.order_by,
    order_dir: params.order_dir,
    page_size: params.page_size,
    page_number: params.page_number
  };
  const url = `/api/staffs/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url);
};

// Get a single staff member by slug
export const getStaffMember = (slug) => {
  const url = `/api/staffs/${slug}`;
  return get(url);
};

// Create a new staff member
export const createStaffMember = (data) => {
  const url = '/api/staffs/';
  return post(url, data);
};

// Update a staff member
export const updateStaffMember = (data) => {
  const url = `/api/staffs/${data.slug}`;
  return put(url, data);
};

export const updateStaffUserInfo = (slug, userData) => {
  const url = `/api/staffs/${slug}`;
  return put(url, userData);
};

// Upload staff avatar
export const uploadStaffAvatar = (slug, photo) => {
  const url = `/api/staffs/${slug}`;
  const form = new FormData();
  form.append('avatar', photo);
  return putImage(url, form);
};

// Delete a staff member
export const deleteStaffMember = (slug) => {
  const url = `/api/staffs/${slug}`;
  return remove(url);
};

// Resend activation email to a staff member
export const resendActivationEmail = (staffSlug) => {
  const url = '/api/staff/invitation';
  return post(url, { staff_slug: staffSlug });
};

// Check activation token validity
export const checkActivationToken = (token) => {
  const url = `/api/activation/check/${token}/`;
  return get(url);
};

// Set password and activate account
export const activateAccount = (token, data) => {
  const url = `/api/activation/complete/${token}/`;
  return post(url, data);
};

// Staff invitation
export const sendStaffInvitation = (data) => {
  const url = '/api/staff/invitation';
  return post(url, data);
};

export const validateInvitation = (key) => {
  const params = { key };
  const url = `/api/accept-invitation?${qs.stringify(params, { skipNulls: true })}`;
  return get(url);
};

export const acceptInvitation = (data) => {
  const url = '/api/accept-invitation';
  return post(url, data);
};

// Staff Community Management
export const getStaffCommunities = (params) => {
  const url = `/api/staff/communities/?${qs.stringify(params, { skipNulls: true })}`;
  return get(url);
};

export const getStaffCommunity = (slug) => {
  const url = `/api/staff/communities/${slug}`;
  return get(url);
};

export const createStaffCommunity = (data) => {
  const url = '/api/staff/communities/';
  return post(url, data);
};

export const updateStaffCommunity = (slug, data) => {
  const url = `/api/staff/communities/${slug}`;
  // If data is FormData (for image uploads), use putImage, otherwise use put
  if (data instanceof FormData) {
    return putImage(url, data);
  }
  return put(url, data);
};

export const deleteStaffCommunity = (slug) => {
  const url = `/api/staff/communities/${slug}`;
  return remove(url);
};

// Work Area Management
export const updateManagementWorkArea = (data, slug) => {
  const url = `/api/management/work-area/${slug}`;
  // If data is FormData (for image uploads), use putImage, otherwise use put
  if (data instanceof FormData) {
    return putImage(url, data)
  }
  return put(url, data)
}

export const addManagementWorkArea = (data) => {
  const url = `/api/management/work-area/`;
  // If data is FormData (for image uploads), use putImage, otherwise use put
  return post(url, data)
}

export const bulkActivateWorkAreaResources = (workAreaSlug, resourceType = null) => {
  const url = `/api/management/work-area/${workAreaSlug}/bulk-activate-resources/`;
  const data = resourceType ? { resource_type: resourceType } : {};
  return post(url, data);
};

// Resource Management
export const updateResourceManagement = (data, slug) => {
  const url = `/api/management/resource/${slug}`;
  // If data is FormData (for image uploads), use postImage, otherwise use post
  if (data instanceof FormData) {
    return putImage(url, data)
  }
  return put(url, data)
}

// Resource Management
export const addResourceManagement = (data) => {
  const url = `/api/management/resource/`;
  // If data is FormData (for image uploads), use postImage, otherwise use post
  return post(url, data)
}

// Venue Services
// Get all available venue services (for the dropdown search)
export const getVenueServices = (searchQuery = '') => {
  const url = '/api/venue-services/';
  const params = searchQuery ? `?search=${encodeURIComponent(searchQuery)}` : '';
  return get(`${url}${params}`);
};

// Get venue-specific services (current services for this venue)
export const getVenueServiceOfferings = (venueSlug) => {
  const url = `/api/venues/${venueSlug}/services/`;
  return get(url);
};

// Update venue services (bulk update - replaces all services)
export const updateVenueServices = (venueSlug, servicesData) => {
  const url = `/api/venues/${venueSlug}/services/`;
  return put(url, { services: servicesData });
};

// Work Area Images
export const getWorkAreaImages = (params) => {
  const url = `/api/work-area-images/${params ? `?${qs.stringify(params, { skipNulls: true })}` : ''}`;
  return get(url);
};

export const getWorkAreaImageDetail = (slug) => {
  const url = `/api/work-area-images/${slug}`;
  return get(url);
};

export const uploadWorkAreaImage = (data) => {
  const url = '/api/work-area-images/';
  // If data is FormData (for image uploads), use postImage, otherwise use post
  if (data instanceof FormData) {
    return postImage(url, data);
  }
  return post(url, data);
};

export const updateWorkAreaImage = (slug, data) => {
  const url = `/api/work-area-images/${slug}`;
  // If data is FormData (for image uploads), use putImage, otherwise use put
  if (data instanceof FormData) {
    return putImage(url, data);
  }
  return put(url, data);
};

export const deleteWorkAreaImage = (slug) => {
  const url = `/api/work-area-images/${slug}`;
  return remove(url);
};

export const reorderWorkAreaImages = (data) => {
  const url = '/api/work-area-images/reorder/';
  return post(url, data);
};

// Resource Images
export const getResourceImages = (params) => {
  const url = `/api/resource-images/${params ? `?${qs.stringify(params, { skipNulls: true })}` : ''}`;
  return get(url);
};

export const getResourceImageDetail = (slug) => {
  const url = `/api/resource-images/${slug}`;
  return get(url);
};

export const uploadResourceImage = (data) => {
  const url = '/api/resource-images/';
  // If data is FormData (for image uploads), use postImage, otherwise use post
  if (data instanceof FormData) {
    return postImage(url, data);
  }
  return post(url, data);
};

export const updateResourceImage = (slug, data) => {
  const url = `/api/resource-images/${slug}`;
  // If data is FormData (for image uploads), use putImage, otherwise use put
  if (data instanceof FormData) {
    return putImage(url, data);
  }
  return put(url, data);
};

export const deleteResourceImage = (slug) => {
  const url = `/api/resource-images/${slug}`;
  return remove(url);
};

export const reorderResourceImages = (data) => {
  const url = '/api/resource-images/reorder/';
  return post(url, data);
};

// Get internal messages (inbox)
export const getInternalMessages = (params) => {
  const getParams = {
    type: params?.type,
    status: params?.status,
    group: params?.group,
    page_size: params?.page_size,
    page_number: params?.page_number,
  };

  const url = `/api/internal-messages/?${qs.stringify(getParams, { skipNulls: true })}`;
  return get(url);
};

// Create internal message
export const createInternalMessage = (data) => {
  const url = '/api/internal-messages/';
  return post(url, data);
};

// Get specific message details
export const getInternalMessageDetail = (messageId) => {
  const url = `/api/internal-messages/${messageId}/`;
  return get(url);
};

// Message actions (mark read, star, archive, reply, etc.)
export const performMessageAction = (messageId, actionData) => {
  const url = `/api/internal-messages/${messageId}/actions/`;
  return post(url, actionData);
};

// Get inbox stats
export const getInboxStats = () => {
  const url = '/api/internal-messages/stats/';
  return get(url);
};

// Convenience functions for specific actions
export const markMessageAsRead = (messageId) => {
  return performMessageAction(messageId, { action: 'mark_read' });
};

export const toggleMessageStar = (messageId) => {
  return performMessageAction(messageId, { action: 'toggle_star' });
};

export const acknowledgeMessage = (messageId) => {
  return performMessageAction(messageId, { action: 'acknowledge' });
};

export const archiveMessage = (messageId) => {
  return performMessageAction(messageId, { action: 'archive' });
};

export const replyToMessage = (messageId, body, parentReplyId = null) => {
  return performMessageAction(messageId, {
    action: 'reply',
    body: body,
    parent_reply_id: parentReplyId
  });
};

export const postMembershipApproval = (communitySlug, membershipSlug, data) => {
  const url = `/api/community/${communitySlug}/membership/${membershipSlug}/approval/`
  return post(url, data)
}


// Update community information
export const updateCommunityInfo = (slug, data) => {
  const url = `/api/community/${slug}`
  return put(url, data)
}

export const updateCommunityImage = (slug, data) => {
  const url = `/api/community/${slug}`
  return putImage(url, data)
}

// Get available tags for communities
export const getAvailableTags = () => {
  const url = `/api/tags/`
  return get(url)
}

export const updateMembershipProfile = (membershipSlug, data) => {
  const url = `/api/membership/${membershipSlug}/profile/`
  return put(url, data)
}

export const leaveCommunity = (membershipSlug) => {
  const url = `/api/membership/${membershipSlug}/leave/`
  return post(url, { confirm: true })
}

export const reportCommunity = (communitySlug, data) => {
  const url = `/api/community/${communitySlug}/report/`
  return post(url, data)
}

// Community Invitations
export const inviteCommunityMembers = (communitySlug, data) => {
  const url = `/api/community/${communitySlug}/invite/`
  return post(url, data)
}

export const getCommunityInvitations = (communitySlug) => {
  const url = `/api/community/${communitySlug}/invite/`
  return get(url)
}

export const cancelCommunityInvitation = (communitySlug, token) => {
  const url = `/api/community/${communitySlug}/invite/cancel/`
  return post(url, { token })
}

export const validateCommunityInvitation = (token) => {
  const url = `/api/community-invitation/?token=${token}`
  return get(url)
}

export const acceptCommunityInvitation = (token) => {
  const url = `/api/community-invitation/`
  return post(url, { token })
}